import { MatrixItem, SizeItem, SizeTableMale } from '@/types/size'

// Format bảng size để render với TableSize component
interface TableSizeFormatted {
  rows: SizeItem[]
  columns: SizeItem[]
  matrix: MatrixItem[]
  headerTitle?: string
  leftTitle?: string
  image?: string
  title?: string
}

export const SizeFormatter = {
  formatSizeTable: (data: SizeTableMale): TableSizeFormatted => {
    // Trường hợp không có dữ liệu
    if (!data || !data.table || data.table.length === 0) {
      return {
        rows: [],
        columns: [],
        matrix: [],
        image: '',
      }
    }

    // Lấy giá trị size (thường là hàng đầu tiên trong table) làm các cột
    const sizeRow = data.table.find((row) =>
      row.title.toLowerCase()?.includes('size')
    )

    if (!sizeRow) {
      return {
        rows: [],
        columns: [],
        matrix: [],
        image: '',
      }
    }

    // Tạo columns từ các giá trị trong hàng size
    const columns: SizeItem[] = sizeRow.value.map((val, index) => ({
      id: index + 1,
      name: val,
    }))

    // Tạo rows từ các hàng còn lại (trừ hàng size), row.title phải có value
    const rowsData = data.table.filter(
      (row) => row.value.length > 0 && row.title.toLowerCase() !== 'size'
    )
    const rows: SizeItem[] = rowsData.map((row, index) => ({
      id: index + 1,
      name: row.title,
    }))

    // Tạo matrix cho từng ô trong bảng
    const matrix: MatrixItem[] = []

    rowsData.forEach((row, rowIndex) => {
      row.value.forEach((cellValue, colIndex) => {
        matrix.push({
          rowId: rowIndex + 1,
          columnId: colIndex + 1,
          value: cellValue,
        })
      })
    })

    return {
      rows,
      columns,
      matrix,
      headerTitle: 'SIZE',
      leftTitle: 'THÔNG SỐ',
      title: 'Thông số sản phẩm',
      image: data.image,
    }
  },
}
